import { AfterViewInit, Component, inject } from '@angular/core';
import { AuthService } from 'src/app/service/auth.service';
import { WebViewInteropService } from 'src/app/service/web-view-interop.service';
import { environment } from 'src/environments/environment';
import { NgClass } from '@angular/common';
import { PublicEventsService } from 'angular-auth-oidc-client';

/*
This component will trigger the login flow with MSAL
Please look into app.module.ts to see the configuration for MSAL
*/
@Component({
    selector: 'app-login-page',
    templateUrl: './login-page.component.html',
    styleUrls: ['./login-page.component.css'],
    imports: [NgClass]
})
export class LoginPageComponent implements AfterViewInit {
  environmentText = environment.type;
  environmentVersion = environment.version;
  isAuthenticated: boolean = false;

  constructor(private authService: AuthService, private webViewInterop: WebViewInteropService, ) { }
  private readonly eventService = inject(PublicEventsService);
  async ngAfterViewInit() {
    this.autoLogin();
  }

  async loginSilent() {
    this.isAuthenticated = true;
    try {
      this.isAuthenticated = await this.authService.loginAllProviders();
    }
    catch (error){
      console.error("Login failed: ", error);
    }
  }

  async autoLogin() {
    try {
      await this.authService.checkLogin();
    }
    catch {
      this.isAuthenticated = false;
    }

  }

  reload() {
    window.location.reload();
  }

  closeApp() {
    this.webViewInterop.postMessageToClient("closeAppEvent");
  }

}
